import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { notificationCountSelector } from '../notifications/data-access/notification.selectors';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationComponent } from '../notifications/notification.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CreatePrfFromFilePopupComponent } from '../create-prf-from-file-popup/create-prf-from-file-popup.component';

@Component({
    selector: 'app-customer-company-list-header',
    templateUrl: './company-list-header.component.html',
    styleUrls: ['./company-list-header.component.scss'],
    standalone: false
})
export class CustomerCompanyListHeaderComponent implements OnInit {
  @Input() headerDetailsLoaded: boolean;
  @Input() isReadOnlyAdmin: boolean;
  @Input() isAdmin: boolean;
  @Input() groupcode: string;
  @Input() groupname: string;
  @Input() custid: string;
  @Input() currentYear: number;
  @Input() showspingetprfyears: boolean;
  @Input() yearList: number[] = [];
  @Output() onClickAddNewForm = new EventEmitter();
  @Output() onOpenCompanyInformation = new EventEmitter();
  notificationCount$: Observable<number>;

  constructor(private store: Store, 
              private modalService: NgbModal,
              private route: ActivatedRoute,
              private router: Router
            ) {
    
  }

  ngOnInit(): void {
    this.notificationCount$ = this.store.select(notificationCountSelector);

    this.route.queryParams.subscribe((params) => {
      if (params['openNotification'] === 'true') {
        this.openNotificationWindow();
      }
    });
  }

  openNotificationWindow() {
    const modelRef = this.modalService.open(NotificationComponent, { size: 'lg' });
    modelRef.componentInstance.openCompanyInformation = this.onOpenCompanyInformation;
    modelRef.componentInstance.currentYear = this.currentYear;
  }

  addNewForm() {
    this.onClickAddNewForm.emit();
  }

  navigateToRequests(): void {
    this.router.navigate(['/requests']);
  }

  get isLatestYear(): boolean {
    return this.yearList.length === 0 || Number(this.currentYear) === Math.max(...this.yearList);
  }

 // Open the Create PRF from File modal
  openCreatePrfFromFileModal(): void {
    const modalRef = this.modalService.open(CreatePrfFromFilePopupComponent, {

    });
    modalRef.componentInstance.prfyear = this.yearList.length > 0 ? Math.max(...this.yearList) : this.currentYear;
    modalRef.result.then(
      (result) => {
        if(result=='restart'){
          this.openCreatePrfFromFileModal()
        }
        return;
      },
      () => {
      }
    );
  }
}
